import PhysicsWorld from '../../logic/loop/PhysicsWorld'

import styled from 'styled-components'
import { Box, Tooltip } from '@material-ui/core'

import GhostIcon from 'mdi-material-ui/Ghost'
import { shape } from '../../theme'
import { useEffect } from 'react'
import { useState } from 'react'

const EntityCountRoot = styled.div`
	display: flex;
	align-items: center;
	
	color: white;

	white-space: nowrap;
`

export default function EntityCount({ physicsWorld = undefined as (undefined | PhysicsWorld) }) {

	const [entityCount, setEntityCount] = useState(0)

	useEffect(() => {
		if (physicsWorld) {
			const trackingInterval = setInterval(() => {
				setEntityCount(
					physicsWorld.getItems().reduce((acc, item) => {
						return acc + 1
					}, 0)
				)
			}, 1000)

			return () => {
				clearInterval(trackingInterval)
			}
		}
	}, [physicsWorld])

	return (
		<EntityCountRoot>
			<Box p="6px 12px">
				<Tooltip title="Entity count">
					<GhostIcon fontSize="small" />
				</Tooltip>
			</Box>
			<Box borderRadius={shape.borderRadius} p="4px 12px" bgcolor="rgba(255, 255, 255, 0.12)">
				{entityCount}
			</Box>
		</EntityCountRoot>
	)
}
